import { initializeApp, getApps, getApp } from 'firebase/app';
import { getMessaging, isSupported } from 'firebase/messaging';

// CliClaim-bussiness Firebase project — these values are the public web app
// config (safe to ship client-side, unlike the backend's service account
// private key). Registered as the "cliclaim-web" app in that project.
const firebaseConfig = {
  apiKey: 'AIzaSyA7YNryu6YDNRDYASORfBYq_VtENEEQMYk',
  authDomain: 'cliclaim-bussiness.firebaseapp.com',
  projectId: 'cliclaim-bussiness',
  storageBucket: 'cliclaim-bussiness.firebasestorage.app',
  messagingSenderId: '1043048292490',
  appId: '1:1043048292490:web:95e343819f03cd85540d73',
  measurementId: 'G-3DN1QGNH3X'
};

// Web Push certificate (VAPID key) from Project settings → Cloud Messaging.
export const FCM_VAPID_KEY =
  'BJeBzC7yDK9LD4h8adqWa-ho6D9WK_CprklyqHWPlG4J0Y0F60tyhOLWnM40Kfwne_9rSme2xsrIcvV20FUebWw';

export const firebaseApp = getApps().length ? getApp() : initializeApp(firebaseConfig);

// Firebase Messaging isn't supported everywhere (Safari has partial/no
// support, private browsing can block it, etc.) — isSupported() resolves
// false instead of throwing, so callers can no-op gracefully.
export async function getFirebaseMessaging() {
  const supported = await isSupported().catch(() => false);
  if (!supported) return null;
  return getMessaging(firebaseApp);
}
